import axios from 'axios'
import { fromJS } from 'immutable'
import { TOP_LAYER_OF_BASEMAP } from '../constants'
import DataManager from './DataManager'

import config from '../content/config'

export const getMapboxStyleWithFreshCartoUrl = (map, onSuccess) => {
	//Direct call to the CARTO Maps API, now with Mapbox Vector Tiles support
	const mapConfig = encodeURIComponent(JSON.stringify(
		{
			layers: DataManager.getCartoDataLayers().map(layerId => {
				return {id: layerId, options: {sql: DataManager.getCartoDataForLayerId(layerId).sql}}
			})
		}
		)
	)

	axios.get( `${config.CARTO_SERVER}/user/${config.CARTO_USER}/api/v1/map?config=${mapConfig}&api_key=${DataManager.readOnlyCartoApiKey()}`)
		.then(
			resp => {
				resp.data.metadata.layers.forEach(layer => {
					const { id } = layer
					const cartoSource = {
						type: 'vector',
						tiles: layer.tilejson.vector.tiles,
					}
					map.addSource(id, cartoSource)
					map.addLayer(DataManager.getStyleForCartoLayer(id), TOP_LAYER_OF_BASEMAP)
				})

				onSuccess(fromJS(map.getStyle()))
			})
}

export const getCartoData = (sqlQueries = [], apiKey, onDataLoaded = false) => {
	const DEV_SQL_CLIENT = axios.create({
		method: 'get',
		url: `${config.CARTO_SERVER}/user/${config.CARTO_USER}/api/v2/sql`
	})

	/* make a request and put callbacks for success and error events */
	const promises = sqlQueries.map(sqlQuery => DEV_SQL_CLIENT.request({
		params: { q: sqlQuery.query, api_key: apiKey, data: sqlQuery }
	}))

	const requests = axios.all(promises)
	if (onDataLoaded) {
		requests.then(responses => {
			onDataLoaded(responses)
		})
	}
	return requests
}
